export enum Location {
  ACTIVE = 'active',
  DISABLED = 'disabled',
  DEFAULT = 'default'
}
